import { ButtonText } from '@/components/common/Button'
import { FloatingTooltip } from '@/components/common/Floating'
import { Icon } from '@/components/icons/Icon'
import { galleryActions } from '@/store/gallery'
import { useReduxDispatch } from '@/store/hooks'

import { useGalleryDisplay } from '../../GalleryDisplayProvider/GalleryDisplayProvider'

import styles from './GalleryControlsReset.module.scss'

export const GalleryControlsReset = () => {
  const { editedCount } = useGalleryDisplay()
  const dispatch = useReduxDispatch()

  const onClick = () => {
    dispatch(galleryActions.reset())
  }

  return (
    editedCount > 0 && (
      <div className={styles.container}>
        <FloatingTooltip content={<p>Reset gallery settings</p>}>
          <ButtonText aria-label='Reset gallery settings' onClick={onClick} size='lg'>
            <span className={styles.button}>
              <Icon name='rotateLeft' />
            </span>
          </ButtonText>
        </FloatingTooltip>
      </div>
    )
  )
}
